<template>
    <navbar />
</template>

<script>

</script>